
   <wp-embedded-table *ngIf="!resultsHidden"
                      [queryProps]="queryProps"
                      [configuration]="tableConfiguration">
    </wp-embedded-table>
  